<template>
    <div class="view view--add-startdesk">
        <div class="view--add-startdesk__step-1" v-if="!category">
            <router-link class="btn is-large is-primary view--add-tile__step-1__btn"
                         v-bind:to="{ name: 'startdesks.add', params: { category: 'custom' } }">
                <span class="jam jam-plus"></span>{{ __('Add empty startdesk') }}
            </router-link>

            <span class="view__separator"><span>{{ __('or choose category') }}</span></span>

            <category-list category-type="startdesks"
                           v-bind:list-link="{ name: 'startdesks.add' }"
            />
        </div>

        <edit-startdesk category="custom" v-if="category && category == 'custom'" />

        <startdesk-list list-type="add"
                v-bind:category="parseInt(category)"
                v-bind:is-visible-to-user-filter="true"
                v-bind:selectable="true"
                v-bind:show-actions="false"
                v-bind:show-add-button="false"
                v-bind:show-add-to-my-startdesks-button="true"
                v-bind:show-back-button="true"
                v-bind:show-filters="{ 'category': true }"
                v-bind:show-title="false"
                v-if="category && category != 'custom'"
        />
    </div>
</template>

<script>
    import categoryList from '../../components/CategoryList.vue';
    import editStartdesk from '../../components/EditStartdesk.vue';
    import startdeskList from '../../components/StartdeskList.vue';

    export default {
        beforeRouteUpdate: function (to, from, next) {
            this.category = to.params.category || null;

            next();
        },
        components: {
            categoryList,
            editStartdesk,
            startdeskList
        },
        data: function () {
            return {
                category: this.$route.params.category || null
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/startdesks/Add.vue